import React from "react";
import { Download } from "lucide-react";

function SessionBrousher() {
  const handleOpenPDF = () => {
    window.open("/session.pdf", "_blank");
  };

  return (
    <div className="p-0">
      <button
        onClick={handleOpenPDF}
        className="relative overflow-hidden inline-flex items-center gap-2 px-4 py-2 text-sm rounded-full bg-gradient-to-r from-blue-900 via-blue-600 to-indigo-600 text-white font-semibold shadow-md hover:shadow-2xl transform transition-all duration-300 hover:scale-110 group"
      >
        <span className="absolute inset-0 bg-gradient-to-r from-white/10 via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm" />

        <Download className="w-4 h-4 animate-bounce-slow" />

        <span className="z-10">Download Brochure</span>

        {/* Glow pulse effect */}
        <span className="absolute -inset-1 rounded-full bg-gradient-to-r from-pink-500 via-blue-500 to-purple-500 opacity-20 blur-md group-hover:opacity-40 transition-opacity duration-500"></span>
      </button>
    </div>
  );
}

export default SessionBrousher;
